import keyCodeToCodes from './modules/keyCodeToCodes';
export default keyCodeToCodes;
